import { textEditingUpdateTextMaker } from 'utils/actions';

export const FEEDBACK_EDITING_UPDATE_SUBJECT = 'FEEDBACK_EDITING_UPDATE_SUBJECT';
export const feedbackEditingUpdateSubject = subject => ({type: FEEDBACK_EDITING_UPDATE_SUBJECT, subject});

export const FEEDBACK_EDITING_UPDATE_TEXT = 'FEEDBACK_EDITING_UPDATE_TEXT';
export const feedbackEditingUpdateText = textEditingUpdateTextMaker(FEEDBACK_EDITING_UPDATE_TEXT);

export const FEEDBACK_EDITING_RESET = 'FEEDBACK_EDITING_RESET';
export const feedbackEditingReset = () => ({type: FEEDBACK_EDITING_RESET});

export const FEEDBACK_EMOJIS_SHOW = 'FEEDBACK_EMOJIS_SHOW';
export const feedbackEmojisShow = key => ({type: FEEDBACK_EMOJIS_SHOW, key});

export const FEEDBACK_EMOJIS_HIDE = 'FEEDBACK_EMOJIS_HIDE';
export const feedbackEmojisHide = key => ({type: FEEDBACK_EMOJIS_HIDE, key});

export const FEEDBACK_CREATE = 'FEEDBACK_CREATE';
export const FEEDBACK_CREATE_SUCCESS = 'FEEDBACK_CREATE_SUCCESS';
export const FEEDBACK_CREATE_ERROR = 'FEEDBACK_CREATE_ERROR';
export const feedbackCreate = (subject, text, successMessage) => ({type: FEEDBACK_CREATE, subject, text, successMessage});



/** WEBPACK FOOTER **
 ** ./src/members/state/feedback/actions.js
 **/